import BaseLayout from '@/components/BaseLayout.vue'
import api from '@/services/api';

export default {
    name: 'education-tests',

    data() {
        return {
            quizzes: [],
        };
    },

    components: {
        BaseLayout
    },

    methods: {
        /**
         * Get education videos from API
         */
        getTests() {
            api.get('/api/get_promotion_education_quizzes')
                .then((response) => {
                    this.quizzes = response.data.body.entries.filter((quiz) => {
                        return quiz.active && !quiz.archived
                    });
                });
        },
    },

    watch: {
        'user.pcmsId': function (){
            this.getTests();
        }
    },

    mounted() {
        this.getTests();
    },
}
